import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Store} from '@ngxs/store';
import {firstValueFrom, Observable} from 'rxjs';
import {Loader} from '../../models/loader/loader.redux';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {AuthActions, AuthState, IUser} from '../../models/auth';
import {StorageService} from '../../services/storage/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivateChild {

  constructor(
    private router: Router,
    private store: Store,
    private messageAlertService: MessageAlertService,
    private storageService: StorageService,
  ) { }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Promise<boolean>(async (resolve, reject) => {
      await firstValueFrom((this.store.dispatch(new Loader(true))));
      const userToken = this.storageService.getLocalItem<{ user: IUser, token: string }>('user');

      if (!userToken?.token) {
        // this.messageAlertService.createMessage('error', this.messageAlertService.messages.sessionExpired);
        await this.router.navigate(['auth/new/landing']);
        await firstValueFrom((this.store.dispatch(new Loader(false))));
        reject(new Error('Unauthenticated.'));
        return;
      }

      await firstValueFrom((this.store.dispatch(new AuthActions.IsLogged())));
      const isLogged = await firstValueFrom((this.store.selectOnce(AuthState.getIsLoggedOnly)));
      if (isLogged) {
        await firstValueFrom((this.store.dispatch(new AuthActions.SetUser(userToken.user))));
        await firstValueFrom((this.store.dispatch(new Loader(false))));
        resolve(true);
        return;
      }

      // this.messageAlertService.createMessage('error', this.messageAlertService.messages.sessionExpired);
      await this.router.navigate(['auth/new/landing']);
      await firstValueFrom((this.store.dispatch(new Loader(false))));
      reject(new Error('Unauthenticated.'));
      return;
    });
  }
}
